import React, { memo } from 'react'
import { Link } from 'react-router-dom'
import { ILoadBoardPost } from 'types/loadBoardPosts'
import { IShipment } from 'types/shipment'
import { EQUIPMENT } from 'constants/equipment'
import { PostList } from './PostList'

interface ISimilarPostsProps {
  shipment?: IShipment
  posts: ILoadBoardPost[]
}

interface IURLFilterParams {
  pickupCity: string
  pickupStateCode: string
  deliveryCity: string
  deliveryStateCode: string
  pickupDate: string
  equipment: {
    name: string
    id: number
  }
}

const makeUrlParams = ({
  deliveryCity,
  deliveryStateCode,
  equipment,
  pickupCity,
  pickupDate,
  pickupStateCode,
}: IURLFilterParams) =>
  decodeURI(
    JSON.stringify({
      filters: {
        pickupCity,
        pickupStateCode,
        deliveryCity,
        deliveryStateCode,
        pickupDate,
        equipment,
        status: ['tendered', 'waterfall_offered', 'alerted', 'reserved'],
      },
      sortField: 'pickups',
      sortOrder: 'asc',
      pageCount: 0,
    })
  )

export const SimilarPosts = memo<ISimilarPostsProps>(({ posts, shipment }) => {
  const firstPickup = shipment?.stops
    .filter(s => s.type === 'pickup')
    .sort((a, b) => a.stopSequence - b.stopSequence)[0]
  const lastDelivery = shipment?.stops
    .filter(s => s.type === 'delivery')
    .sort((a, b) => b.stopSequence - a.stopSequence)[0]

  const pCity = firstPickup?.facility.city
  const pState = firstPickup?.facility.stateCode
  const pDate = firstPickup?.appointment.startAtDate

  const dCity = lastDelivery?.facility.city
  const dState = lastDelivery?.facility.stateCode

  const equipment = EQUIPMENT.find(e => e.key === shipment?.equipment.parentKey) || EQUIPMENT[0]
  const { name: equipmentType } = equipment
  const dropText = shipment?.info.dropTrailer && 'Drop'
  const teamText = shipment?.info.team && 'Team'
  const linkText = [
    `${pCity}, ${pState} – ${dCity}, ${dState}`,
    `Pickup ${pDate}`,
    equipmentType,
    dropText,
    teamText,
  ]
    .filter(k => k)
    .join(' · ')

  return (
    <>
      <div className='row'>
        <div className='fl'>
          <div className='body-medium'>Also posted for this lane and date</div>
          <div className='text-caption-semibold'>
            <div>
              <strong className='text-caption'>Showing {posts.length} active posts</strong> for
              shipments matching
            </div>
            <div>
              <Link
                to={`/?query=${makeUrlParams({
                  pickupCity: pCity || '',
                  pickupStateCode: pState || '',
                  deliveryCity: dCity || '',
                  deliveryStateCode: dState || '',
                  pickupDate: pDate || '',
                  equipment,
                })}`}
                target='_blank'>
                {linkText}
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className='row mv4'>
        <PostList
          posts={posts}
          loading={false}
          error=''
          noPostMessage='There are no similar DAT posts for this shipment'
        />
      </div>
    </>
  )
})
